import types from '@/store/types';

import { auth } from '@/plugins/firebase';

import projectCategories from './ops/categories.actions';
import projectStages from './ops/stages.actions';
import projectFeatures from './ops/features.actions';
import projectPlans from './ops/plans.actions';
import projects from '@/modules/projects/projects.actions';
import contacts from './ops/contacts.actions';
import estimates from './ops/estimates.actions';
import issues from '@/modules/issues/issues.actions';
import timesheets from './ops/timesheets.actions';
import expenses from './ops/expenses.actions';
import roles from './ops/roles.actions';
import users from './ops/users.actions';
import stats from './ops/stats.actions';

const actions = {
  [types.SYNC_USER]({
    rootState,
    commit,
    getters,
  }, payload) {
    const {
      uid,
      email,
      displayName,
      emailVerified,
      photoURL,
      isAnonymous,
      escapeValidation,
    } = payload;
    return getters.usersCollection.doc(uid).set({
      uid,
      email,
      displayName,
      emailVerified,
      photoURL,
      isAnonymous,
    }, {
      merge: true,
    }).then(() => {
      if (!escapeValidation) {
        commit(types.SHOW_SNACKBAR, {
          message: rootState.messages.USER_UPDATE_SUCCESS,
        }, { root: true });
      }
    }).catch((error) => {
      if (!escapeValidation) {
        commit(types.SHOW_SNACKBAR, {
          color: 'error',
          message: error.message,
        }, { root: true });
      }
    });
  },
  [types.UPDATE_AND_SYNC_USER]({
    rootState,
    commit,
  }, payload) {
    const {
      displayName,
      phoneNumber,
      photoURL,
      escapeValidation,
    } = payload;
    return auth.currentUser.updateProfile({
      displayName,
      photoURL,
      phoneNumber,
    }).then(() => {
      commit(types.UPDATE_LOCAL_USER, {
        displayName,
        phoneNumber,
        photoURL,
      }, { root: true });
      if (!escapeValidation) {
        commit(types.SHOW_SNACKBAR, {
          message: rootState.messages.USER_UPDATE_SUCCESS,
        }, { root: true });
      }
    }).catch((error) => {
      if (!escapeValidation) {
        commit(types.SHOW_SNACKBAR, {
          color: 'error',
          message: error.message,
        }, { root: true });
      }
    });
  },
  ...projectCategories,
  ...projectStages,
  ...projectFeatures,
  ...projectPlans,
  ...projects,
  ...contacts,
  ...issues,
  ...estimates,
  ...timesheets,
  ...expenses,
  ...roles,
  ...users,
  ...stats,
};

export default actions;
